<template>
  <div class="wrapper app-content">
    <div v-if="isBasic">
      <div class="tilte-text"> 选择购票方式</div>
      <div class="select-wrap">
        <el-row :gutter="19">
<!--          <el-col :span="6">-->
<!--            <div class="select-box" @click="selectMethod(0)" :style="getStyleObj(0)">-->
<!--              <div class="select-div">-->
<!--                <img class="method-img" :src="getSelectImgSrc(0)" alt="">-->
<!--                <div class="method">竞价购票</div>-->
<!--              </div>-->
<!--              <img class="select-img" :src="getImgObj(0)" alt="">-->
<!--            </div>-->
<!--          </el-col>-->
          <el-col :span="6">
            <div class="select-box" @click="selectMethod(1)" :style="getStyleObj(1)">
              <div class="select-div">
                <img class="method-img" :src="getSelectImgSrc(1)" alt="">
                <div class="method">特惠购票</div>
              </div>
              <img class="select-img" :src="getImgObj(1)" alt="">
            </div>
          </el-col>
          <el-col :span="6">
            <div class="select-box" @click="selectMethod(2)" :style="getStyleObj(2)">
              <div class="select-div">
                <img class="method-img" :src="getSelectImgSrc(2)" alt="">
                <div class="method">秒&nbsp;出&nbsp;票</div>
              </div>
              <img class="select-img" :src="getImgObj(2)" alt="">
            </div>
          </el-col>
          <!--          <el-col :span="6">-->
          <!--            <div class="select-box" @click="selectMethod(3)" :style="getStyleObj(3)">-->
          <!--              <div class="select-div">-->
          <!--                <img class="method-img" :src="getSelectImgSrc(3)" alt="">-->
          <!--                <div class="method">特惠秒出</div>-->
          <!--              </div>-->
          <!--              <img class="select-img" :src="getImgObj(3)" alt="">-->
          <!--            </div>-->
          <!--          </el-col>-->
        </el-row>
        <div class="form-group">
          <div class="flex">
            <div style="margin-right: 10px">秒出票让利</div>
            <div class="input-wrap">
              <Input type="number" v-model="promotionForm.secondDiscount"></Input>
            </div>
            <div class="color-666 padding-r-20">%</div>
          </div>
          <div class="color-999 font-12" style="display: flex;flex-direction: row;">
            <div>
              只可填写{{ promotionForm.secondsJeanLeeMinimum }}~{{ promotionForm.secondsJeanLeeMaximum }}之间（含）的整数，例：填写2%则表示将自己所得利益让给用户，用户购票为正常票价的98%，您获得的分润为2%
            </div>
          </div>
        </div>
        <div class="form-title" style="margin-top: 40px">
          购票价折扣浮动设置
        </div>
        <div class="form-div">
          <div class="form-div-text">折扣浮动</div>
          <div class="input-wrap flex" style="margin-top: 0;margin-left: 10px">
            <Input type="number" v-model="promotionForm.ticketDiscountFloat" style="width: 134px;" placeholder="请输入-3～3之间的整数"></Input>
            <div style="margin-left: 5px">%</div>
            <div class="form-div-hint">例：某影票市场价100元，购买价90，则系统折扣为90%。您若设置折扣浮动3%，则购买价变为100x(90%+3%)=93元，设置成功后对所有影票生效。订单成交后，您的佣金=平台按溢价前的购买价结算给您佣金+您的溢价(100x3%)。</div>
          </div>
        </div>
        <div class="bottom">
          <div class="bottom-title"><img src="../../../../assets/img/set_icon_hint.png" alt="">温馨提示：</div>
          <div class="bottom-text">- 若您在投流期间，注重回本周期，可以适当提高定价；若希望提高成交率，可以适当降低定价。</div>
          <div class="bottom-text" style="color: #FF4F76">- 设置折扣浮动，不影响出票成功率和您的佣金结算。定价提高部分是您的专属佣金，平台不会额外抽取利润，也不会影响商家报价上限；同样，定价降低部分也将由你全部承担，结算时将从您的佣金中扣除。</div>
          <div class="bottom-text">- 价格浮动仅对特惠购票的售价生效，快出购票的售价不生效。</div>
        </div>
        <!--        v-if="promotionForm.openSecondsJeanLee == 1"-->
        <div class="save-div">
          <span class="save-btn" @click="saveSet()">确定保存</span>
        </div>
      </div>
    </div>
    <div v-if="!isBasic">
      <div class="tilte-text"> 基本设置</div>
      <div class="setting-wrap">
        <div class="tab-box">
          <div class="tab-div" :class="tabActive == 0 ? 'active' : ''" @click="changeTab(0)">
            <span>推广设置</span>
            <div class="line" v-if="tabActive == 0"></div>
          </div>
          <div class="tab-div" :class="tabActive == 1 ? 'active' : ''" @click="changeTab(1)">
            <span>提现设置</span>
            <div class="line" v-if="tabActive == 1"></div>
          </div>
          <div class="tab-div" :class="tabActive == 2 ? 'active' : ''" @click="changeTab(2)">
            <span>邀请海报</span>
            <div class="line" v-if="tabActive == 2"></div>
          </div>
        </div>
        <div class="form-wrapper" v-if="tabActive == 0">
          <Form ref="promotionForm" :model="promotionForm" label-position="right" :label-width="110">
            <FormItem label="购票方式" prop="isService">
              <div class="form-group">
                <div class="input-wrap" style="min-width: 100%;">
                  <CheckboxGroup v-model="methodGroup" @on-change="checkAllGroupChange">
<!--                    <Checkbox label="竞价购票">-->
<!--                    </Checkbox>-->
                    <Checkbox label="特惠购票">
                    </Checkbox>
                    <Checkbox label="秒出票">
                    </Checkbox>
                    <!--                    <Checkbox label="特惠秒出购票">-->
                    <!--                    </Checkbox>-->
                  </CheckboxGroup>
                </div>
              </div>
            </FormItem>
            <FormItem label="第一级代理分成" prop="prev_1_comm">
              <div class="form-group">
                <div class="input-wrap">
                  <Input type="number" v-model="promotionForm.percentOne"></Input>
                </div>
                <div class="color-999 font-12" style="display: flex;flex-direction: row;">
                  <span class="color-666 padding-r-20">%</span>
                  <div>设置20%表示：您的利润分佣*20%即为一级推广者所得</div>
                </div>
              </div>
            </FormItem>
            <FormItem label="第二级代理分成" prop="prev_2_comm">
              <div class="form-group">
                <div class="input-wrap">
                  <Input type="number" v-model="promotionForm.percentTwo"></Input>
                </div>
                <div class="color-999 font-12" style="display: flex;flex-direction: row;">
                  <span class="color-666 padding-r-20">%</span>
                  <div>设置20%表示：您的利润分佣*20%即为二级推广者所得</div>
                </div>
              </div>
            </FormItem>
            <FormItem label="总监提成" prop="director_comm">
              <div class="form-group">
                <div class="input-wrap">
                  <Input type="number" v-model="promotionForm.percentMajor"></Input>
                </div>
                <div class="color-999 font-12" style="display: flex;flex-direction: row;">
                  <span class="color-666 padding-r-20">%</span>
                  <div>
                    设置50%表示：您的利润分佣扣除一二级代理，剩下的50%为总监分红。扣除一二级佣金和总监分红即为您的平台最终利润。总监用户身份设置请到“会员列表”用户信息详情页面设置
                  </div>
                </div>
              </div>
            </FormItem>
            <FormItem label="秒出票让利" prop="director_comm" v-if="promotionForm.openSecondsJeanLee == 1">
              <div class="form-group">
                <div class="input-wrap">
                  <Input type="number" v-model="promotionForm.secondDiscount"></Input>
                </div>
                <div class="color-999 font-12" style="display: flex;flex-direction: row;">
                  <span class="color-666 padding-r-20">%</span>
                  <div>
                    只可填写{{ promotionForm.secondsJeanLeeMinimum }}~{{ promotionForm.secondsJeanLeeMaximum }}之间（含）的整数，例：填写2%则表示将自己所得利益让给用户，用户购票为正常票价的98%，您获得的分润为2%
                  </div>
                </div>
              </div>
            </FormItem>
            <div class="form-title">
              购票价折扣浮动设置
            </div>
            <div class="form-div">
              <div class="form-div-text">折扣浮动</div>
              <div class="input-wrap flex" style="margin-top: 0;margin-left: 10px">
                <Input type="number" v-model="promotionForm.ticketDiscountFloat" style="width: 134px;" placeholder="请输入-3～3之间的整数"></Input>
                <div style="margin-left: 5px">%</div>
                <div class="form-div-hint">例：某影票市场价100元，购买价90，则系统折扣为90%。您若设置折扣浮动3%，则购买价变为100x(90%+3%)=93元，设置成功后对所有影票生效。订单成交后，您的佣金=平台按溢价前的购买价结算给您佣金+您的溢价(100x3%)。</div>
              </div>
            </div>
            <div class="bottom">
              <div class="bottom-title"><img src="../../../../assets/img/set_icon_hint.png" alt="">温馨提示：</div>
              <div class="bottom-text">- 若您在投流期间，注重回本周期，可以适当提高定价；若希望提高成交率，可以适当降低定价。</div>
              <div class="bottom-text" style="color: #FF4F76">- 设置折扣浮动，不影响出票成功率和您的佣金结算。定价提高部分是您的专属佣金，平台不会额外抽取利润，也不会影响商家报价上限；同样，定价降低部分也将由你全部承担，结算时将从您的佣金中扣除。</div>
              <div class="bottom-text">- 价格浮动仅对特惠购票的售价生效，快出购票的售价不生效。</div>
            </div>
            <FormItem>
              <span class="active-btn confirm-btn" v-on:click="handleSubmit('promotionForm')">确定保存</span>
            </FormItem>
          </Form>
        </div>
        <div class="form-wrapper" v-if="tabActive == 1">
          <Form ref="withdrawForm" :model="withdrawForm" label-position="right" :label-width="110">
            <FormItem label="最低提现金额" prop="withdrawMin">
              <div class="form-group">
                <div class="input-wrap">
                  <Input type="number" v-model="withdrawForm.withdrawMin" placeholder="0"/>
                </div>
                <div class="color-999 font-12"><span class="color-666 padding-r-20">元</span>单笔提现大于最低提现金额才能提现。填写0表示不限制
                </div>
              </div>
            </FormItem>
            <FormItem label="提现必须是" prop="withdrawPart">
              <div class="form-group">
                <div class="input-wrap">
                  <Input type="number" v-model="withdrawForm.withdrawPart" placeholder="填写0表示不限制"></Input>
                </div>
                <div class="color-999 font-12">
                  <span class="color-666 padding-r-20">元的整倍数</span>
                  <span>填写0表示不限制</span>
                </div>
              </div>
            </FormItem>
            <FormItem label="应用APPID" prop="alipay_appid">
              <div class="form-group">
                <div class="input-wrap" style="min-width: 280px;min-width: 280px;">
                  <Input type="number" v-model="withdrawForm.appid" placeholder="支付宝开放平台应用appid"
                         autocomplete="new-password"></Input>
                </div>
                <div class="color-999 padding-l-20 font-12">可不设置，默认使用官方支付宝。若需要更换请联系客服</div>
              </div>
            </FormItem>
            <FormItem label="支付宝公钥" prop="alipay_public_key">
              <div class="form-group">
                <div class="input-wrap" style="max-width: 280px;min-width: 280px;">
                  <Input type="password" v-model="withdrawForm.alipayPublicKey" :placeholder="alipayPublicKeyTip"
                         autocomplete="new-password"></Input>
                </div>
                <div class="padding-l-20 font-12">
                  <div class="padding-r-20 coloe-3d9">使用官方支付宝打款成功将收取<span
                    class="color-ff4">{{ percent }}%</span>的手续费，提现金额和手续费从您的利润余额里扣除。
                  </div>
                  <span class="coloe-3d9">请预留足够的余额，否则用户将提现失败。</span>
                  <div class="color-999">有疑问请<span class="color-ff4 font-14 padding-l-5 cursor-pointer"
                                                       @click="getService()">联系客服</span></div>
                </div>
              </div>
            </FormItem>
            <FormItem label="应用私钥:" prop="application_key">
              <div class="form-group">
                <div class="input-wrap" style="max-width: 280px;min-width: 280px;">
                  <Input type="password" v-model="withdrawForm.privateKey" :placeholder="privateKeyTip"></Input>
                </div>
              </div>
            </FormItem>
            <FormItem label="应用公钥证书" prop="application_crt">
              <el-upload class="upload-demo" :action="ajaxUploadUrl" accept=".crt,.pem" multiple :limit="1"
                         :http-request="ajaxUploadApp"
                         :file-list="appCertList" :before-upload="ajaxBeforeUpload">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <div>只能上传crt格式和pem格式的文件,最多只能上传一个文件，若已上传文件请移除文件列表之后再上传</div>
                </div>
              </el-upload>
            </FormItem>
            <FormItem label="支付宝公钥证书" prop="alipay_public_key">
              <el-upload class="upload-demo" :action="ajaxUploadUrl" accept=".crt,.pem" multiple :limit="1"
                         :http-request="ajaxUploadAlipayPublic"
                         :file-list="certKeyRsaList" :before-upload="ajaxBeforeUploadPublic">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <div>只能上传crt格式和pem格式的文件,最多只能上传一个文件，若已上传文件请移除文件列表之后再上传</div>
                </div>
              </el-upload>
            </FormItem>
            <FormItem label="支付宝CA证书" prop="alipay_ca_key">
              <el-upload class="upload-demo" :action="ajaxUploadUrl" accept=".crt,.pem"
                         :before-upload="ajaxBeforeUpload" multiple :limit="1"
                         :file-list="rootCertList" :http-request="ajaxUploadCA">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <div>只能上传crt格式和pem格式的文件</div>
                </div>
              </el-upload>
            </FormItem>
            <FormItem>
              <span class="active-btn confirm-btn" v-on:click="handleSubmit('withdrawForm')">确定保存</span>
            </FormItem>
          </Form>
        </div>
        <div class="form-wrapper" v-if="tabActive == 2">
          <div class="add-poster">
            <el-upload class="upload-demo" :action="ajaxUploadUrl" accept=".jpg,.png,.bmp,.jpeg,.gif" :multiple="false"
                       :http-request="ajaxUpLoadPoster" :show-file-list="false" :before-upload="ajaxBeforeUpload">
              <el-button size="small" type="primary">添加自定义海报</el-button>
              <div slot="tip" class="el-upload__tip">
                <div>请添加尺寸740*1334，小于10mb的图片</div>
              </div>
            </el-upload>
          </div>
          <div class="poster-wrap">
            <!--系统海报-->
            <div class="poster-wrap-item">
              <div class="tilte-text"> 系统海报</div>
              <div class="poster-item padding-t-20 padding-0-10">
                <div class="poster-box" v-for="(item,index) in posterList" :key="index">
                  <div class="poster-div">
                    <el-image style="width: 120px; height: 213px" :src="item.image" fit="contain"></el-image>
                  </div>
                  <div class="radio-div">
                    <img :src="(isChecked(item.id))?selectIcon:unselectIcon" @click="choosePoster(item)" alt="">
                    <span>启用</span>
                  </div>
                </div>
              </div>
            </div>
            <!--系统海报-->
            <!--自定义海报-->
            <div class="poster-wrap-item">
              <div class="tilte-text"> 自定义海报</div>
              <div class="poster-item padding-t-20 padding-0-10">
                <div v-if="definePosterList.length >0">
                  <div class="poster-box" v-for="(item,index) of definePosterList" :key="index">
                    <div class="poster-div">
                      <el-image style="width: 120px; height: 213px" :src="item.image" fit="contain"></el-image>
                    </div>
                    <div class="flex-space-between">
                      <div class="del-btn" @click="delDefinePoster(item.id)">删除</div>
                      <div class="radio-div">
                        <img :src="(isCheckedDefine(item.id))?selectIcon:unselectIcon" @click="chooseDefinePoster(item)"
                             alt="">
                        <span>启用</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="padding-0-10" v-else>您还未上传自定义海报</div>
              </div>
            </div>
            <!--自定义海报-->
            <!--已启用海报-->
            <div class="poster-wrap-item margin-b-20">
              <div class="tilte-text"> 已启用海报</div>
              <div class="poster-item padding-t-20 padding-0-10">
                <div v-if="curPosterList.length >0">
                  <div class="poster-box" v-for="(item,index) of curPosterList" :key="index">
                    <div class="poster-div">
                      <el-image style="width: 120px; height: 213px" :src="item.image" fit="contain"></el-image>
                    </div>
                    <div class="flex-space-between">
                      <div class="del-btn" @click="delCurPoster(item)">删除</div>
                      <div class="sort-btn" @click="sortCurPoster(item)">升序</div>
                    </div>
                  </div>
                </div>
                <div class="padding-0-10" v-else>您还未启用海报</div>
              </div>
            </div>
            <!--已启用海报-->
          </div>
          <div class="padding-t-40">
            <span class="confirm-btn" v-on:click="handleSubmit()">确定保存</span>
          </div>
        </div>
      </div>
    </div>
    <!--    提现设置-->
    <div class="main" v-if="tabActive == 1">
      <div class="main-title">
        选择提现设置
      </div>
      <div class="main-flex">
        <div class="flex-text">自动审核打款</div>
        <div class="flex-radio">
          <el-radio v-model="openRadio" :label="0" @change="getRadio">关闭</el-radio>
          <el-radio v-model="openRadio" :label="1" @change="getRadio">开启</el-radio>
        </div>
      </div>
      <div class="main-flex">
        <div class="flex-text">审核打款开始时间</div>
        <div class="flex-input">
          <el-input type="number" :maxlength="2" v-model="startTime" placeholder="请输入小时即可"
                    @input="getStartTime"></el-input>
        </div>
      </div>
      <div class="main-flex">
        <div class="flex-text">审核打款结束时间</div>
        <div class="flex-input">
          <el-input type="number" :maxlength="2" v-model="endTime" placeholder="请输入小时即可"
                    @input="getEndTime"></el-input>
        </div>
      </div>
      <div class="main-button">
        <el-button type="primary" @click="saveButton">确定保存</el-button>
      </div>
    </div>
    <Service ref="Service"></Service>
  </div>
</template>

<script>
import {getPlatformUuid, getIsBasic} from '@/utils/auth'
import {getServerConfig, saveSwitch} from '@/api/user'
import Service from '@/views/pc/official/set/modal/Service'
import PublicKey from '@/views/pc/official/set/modal/PublicKey'
import PrivateKey from '@/views/pc/official/set/modal/PrivateKey'
import selectBtn from '@/assets/img/official/set_btn_iselected_2.png'
import unselectBtn from '@/assets/img/official/set_btn_nochoice_1.png'
import biddingS from '@/assets/img/official/set_icon_bidding_s.png'
import biddingN from '@/assets/img/official/set_icon_bidding_n.png'
import preferentialS from '@/assets/img/official/set_icon_preferential_s.png'
import preferentialN from '@/assets/img/official/set_icon_preferential_n.png'
import immediatelyS from '@/assets/img/official/set_icon_immediately_s.png'
import immediatelyN from '@/assets/img/official/set_icon_immediately_n.png'
import discountS from '@/assets/img/official/set_icon_thmc_s.png'
import discountN from '@/assets/img/official/set_icon_thmc_n.png'
import {Form, FormItem, Input, Checkbox, CheckboxGroup} from 'view-design'
import set from '@/javaApi/set'

const setModel = new set()
export default {
  name: 'Set',
  components: {
    selectBtn,
    unselectBtn,
    Form,
    FormItem,
    Input,
    CheckboxGroup,
    Checkbox,
    Service,
    PublicKey,
    PrivateKey
  },
  data: function () {
    return {
      loading: false,
      selectIndex: 0,
      tabActive: 0,
      selectStyleObj: {
        background: '#FFFBF7',
        border: '1px solid #FF8622'
      },
      selectImgObj: {
        biddingSrc: biddingS,
        preferentialSrc: preferentialN,
        immediatelySrc: immediatelyN,
        discountSrc: discountN
      },
      selectIcon: selectBtn,
      unselectIcon: unselectBtn,
      methodGroup: ['竞价购票', '特惠购票', '秒出票', '特惠秒出购票'],
      allMethodGrop: ['竞价购票', '特惠购票', '秒出票', '特惠秒出购票'],
      promotionForm: {
        id: '',
        openCompete: 0,
        openDirect: 0,
        openSoon: 0,
        percentOne: '',
        percentTwo: '',
        percentMajor: '',
        secondDiscount: '',
        secondsJeanLeeMaximum: '',
        secondsJeanLeeMinimum: '',
        openSecondsJeanLee: '',
        ticketDiscountFloat: 0, // 折扣浮动
      },
      withdrawForm: {
        id: '',
        withdrawMin: '',
        withdrawPart: '',
        appid: '',
        alipayPublicKey: '',
        privateKey: '',
        readPublicKey: '',
        readPrivateKey: '',
        ticketType: ''
      },
      percent: 0,
      wechat_code: '',
      posterList: [], //系统海报
      definePosterList: [], //自定义海报
      defineFileList: [], // 用于存储上传临时图片
      curPosterList: [], //已启用海报
      userChoosePosterArr: [], // 系统海报已启用
      userChooseDefinePosterArr: [], // 自定义海报已启用
      selectIndexStr: '0,1',
      ajaxUploadUrl: 'http://127.0.0.1', //el-uploader 必填参数
      alipayCAPath: '',
      alipayPublicKeyPath: '',
      applicationRootPath: '',
      rootCert: '',
      certKeyRsa: '',
      appCert: '',
      startTime: '', // 自动打款开始时间
      endTime: '', // 自动打开结束时间
      openRadio: '0' // 是否开启自动打款
    }
  },
  computed: {
    alipayPublicKeyTip: function () {
      return this.withdrawForm.alipayPublicKey ? '参数已设置' : '参数未设置'
    },
    privateKeyTip: function () {
      return this.withdrawForm.privateKey ? '参数已设置' : '参数未设置'
    },
    platformUuid: function () {
      return getPlatformUuid()
    },
    isBasic: function () {
      return getIsBasic() === 'true' ? true : false
    },
    // type 取值 rsa-支付宝公钥  root -支付宝ca app-应用公钥
    rootCertList: function () {
      if (this.rootCert) {
        return [
          {
            name: this.rootCert
          }
        ]
      } else {
        return []
      }
    },
    appCertList: function () {
      if (this.appCert) {
        return [
          {
            name: this.appCert
          }
        ]
      } else {
        return []
      }
    },
    certKeyRsaList: function () {
      if (this.certKeyRsa) {
        return [
          {
            name: this.certKeyRsa
          }
        ]
      } else {
        return []
      }
    }
  },
  watch: {
    selectIndex: function () {
      this.initImgSrc()
    }
  },
  created: function () {
    console.log(this.userChoosePosterArr)
    this.getPromotionSet()
    this.getWithdrawSet()
    if (!this.isBasic) {
      this.getPosterSet() // 系统海报
      this.getDefinePosterSet() // 自定义海报
      this.getCurPosterSet() // 已启用海报
    }
  },
  methods: {
    handlePublicKey(value) {
      this.withdrawForm.alipayPublicKey = value
    },
    handlePrivateKey(value) {
      this.withdrawForm.privateKey = value
    },
    checkAllGroupChange: function (data) {
      let ticketTypeArr = []
      let methodGroup = []
      if (data.length > 0) {
        let i
        for (i = 0; i < data.length; i++) {
          let tempIndex = this.allMethodGrop.indexOf(data[i])
          if (tempIndex !== -1) {
            methodGroup.push(this.allMethodGrop[tempIndex])
            ticketTypeArr.push(tempIndex)
          }
        }
      }
      this.methodGroup = methodGroup
      console.log(methodGroup)
      this.promotionForm.ticketType = ticketTypeArr.join(',')
    },
    // 获取系统海报
    getPosterSet() {
      let that = this
      setModel.getPosterList({}).then(response => {
        let res = response.data
        if (res.code == 200) {
          that.posterList = res.data
          that.queryCheckPoster()
        } else {
          let message = response.message ? response.message : '系统异常请稍后再试'
          that.$message.error(message)
        }
      })
    },
    // 获取已启用的系统海报
    queryCheckPoster() {
      let that = this
      let param = {}
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (!condition) {
        param.platformUuid = this.platformUuid
      }
      setModel
        .getChoosedPoster(param)
        .then(response => {
          let res = response.data
          if (res.code == 200) {
            if (res.data) {
              let possterArr = []
              let i = 0
              for (i; i < res.data.length; i++) {
                that.userChoosePosterArr[i] = res.data[i]['id']
              }
            }
          } else {
            let message = res.message ? res.message : '系统异常请稍后再试'
            that.$message.error(message)
          }
        })
        .catch(error => {
          that.$message.error('系统异常请稍后再试')
        })
    },
    // 获取自定义海报
    getDefinePosterSet() {
      let that = this
      setModel.getDefinePosterList({platformUuid: this.platformUuid}).then(response => {
        let res = response.data
        if (res.code == 200) {
          that.definePosterList = res.data
          let i = 0
          for (i; i < res.data.length; i++) {
            if (res.data[i].state == 1) {
              that.userChooseDefinePosterArr[i] = res.data[i]['id']
            }
          }
        } else {
          let message = response.message ? response.message : '系统异常请稍后再试'
          that.$message.error(message)
        }
      })
    },
    // 获取已启用海报
    getCurPosterSet() {
      let that = this
      setModel.getCurPoster({platformUuid: this.platformUuid}).then(response => {
        let res = response.data
        if (res.code == 200) {
          that.curPosterList = res.data
        } else {
          let message = response.message ? response.message : '系统异常请稍后再试'
          that.$message.error(message)
        }
      })
    },
    initImgSrc: function () {
      this.selectImgObj = {
        biddingSrc: this.promotionForm.openCompete == 1 ? biddingS : biddingN,
        preferentialSrc: this.promotionForm.openDirect == 1 ? preferentialS : preferentialN,
        immediatelySrc: this.promotionForm.openSoon == 1 ? immediatelyS : immediatelyN,
        discountSrc: this.promotionForm.openMayiSwitch == 1 ? discountS : discountN,
      }
    },
    selectMethod: function (selectIndex) {
      // selectIndex 0-竞价购票 1-特惠购票 2-秒出票
      let targetNum = parseInt(selectIndex)
      console.log('targetNum', targetNum)
      switch (targetNum) {
        case 0:
          this.promotionForm.openCompete = !this.promotionForm.openCompete
          break
        case 1:
          this.promotionForm.openDirect = !this.promotionForm.openDirect
          break
        case 2:
          this.promotionForm.openSoon = !this.promotionForm.openSoon
          break
        case 3:
          this.promotionForm.openMayiSwitch = !this.promotionForm.openMayiSwitch
          break
        default:
      }
    },
    getStyleObj: function (target) {
      // targe 0-竞价购票 1-特惠购票 2-秒出票
      let targetNum = parseInt(target)
      let isCheckStyle = false
      switch (targetNum) {
        case 0:
          isCheckStyle = this.promotionForm.openCompete
          break
        case 1:
          isCheckStyle = this.promotionForm.openDirect
          break
        case 2:
          isCheckStyle = this.promotionForm.openSoon
          break
        case 3:
          isCheckStyle = this.promotionForm.openMayiSwitch
          break
        default:
      }
      if (isCheckStyle) {
        return this.selectStyleObj
      } else {
        return ''
      }
    },
    getSelectImgSrc(target) {
      // targe 0-竞价购票 1-特惠购票 2-秒出票
      let targetNum = parseInt(target)
      let condition = false
      let imgSrcObj
      switch (targetNum) {
        case 0:
          condition = this.promotionForm.openCompete
          if (condition) {
            imgSrcObj = biddingS
          } else {
            imgSrcObj = biddingN
          }
          break
        case 1:
          condition = this.promotionForm.openDirect
          if (condition) {
            imgSrcObj = preferentialS
          } else {
            imgSrcObj = preferentialN
          }
          break
        case 2:
          condition = this.promotionForm.openSoon
          if (condition) {
            imgSrcObj = immediatelyS
          } else {
            imgSrcObj = immediatelyN
          }
          break
        case 3:
          condition = this.promotionForm.openMayiSwitch
          if (condition) {
            imgSrcObj = discountS
          } else {
            imgSrcObj = discountN
          }
          break
        default:
      }
      return imgSrcObj
    },
    getImgObj(target) {
      let targetNum = parseInt(target)
      let selectStyle
      switch (targetNum) {
        case 0:
          selectStyle = this.promotionForm.openCompete
          break
        case 1:
          selectStyle = this.promotionForm.openDirect
          break
        case 2:
          selectStyle = this.promotionForm.openSoon
          break
        case 3:
          selectStyle = this.promotionForm.openMayiSwitch
          break
        default:
          selectStyle = false
      }
      if (selectStyle) {
        return this.selectIcon
      } else {
        return this.unselectIcon
      }
    },
    saveSet: function () {
      if (this.platformUuid == '' || this.platformUuid == 0) {
        this.$Message.error('请绑定公众号！')
        return
      }
      let ticketArr = []
      if (this.promotionForm.openCompete) {
        ticketArr.push(0)
      }
      if (this.promotionForm.openDirect) {
        ticketArr.push(1)
      }
      console.log('this.promotionForm.openSoon', this.promotionForm.openSoon)
      if (this.promotionForm.openSoon) {
        ticketArr.push(2)
      }
      if (this.promotionForm.openMayiSwitch) {
        ticketArr.push(3)
      }
      if(this.promotionForm.ticketDiscountFloat == ''){
        this.$message.error('请输入折扣')
        return;
      }
      if(this.promotionForm.ticketDiscountFloat > 3 || this.promotionForm.ticketDiscountFloat < -3){
        this.$message.error('只能输入-3~3之间的整数')
        return;
      }
      // 不允许输入小数
      if(this.promotionForm.ticketDiscountFloat.toString().indexOf('.') != -1){
        this.$message.error('请输入整数')
        return;
      }
      this.promotionForm.ticketType = ticketArr.join(',')
      setModel
        .savePromotionSet(this.promotionForm)
        .then(response => {
          let res = response.data
          if (res.code == 200) {
            this.$Message.success('保存成功')
          } else {
            let message = res.message ? res.message : '系统繁忙请稍后再试！'
            this.$Message.error(message)
          }
        })
        .catch(error => {
          this.$Message.error('系统繁忙请稍后再试')
        })
    },
    changeTab: function (index) {
      this.tabActive = index
    },
    handleSubmit: function (form) {
      if (this.platformUuid == '' || this.platformUuid == 0) {
        this.$Message.error('请绑定公众号！')
        return
      }
      let secondDiscount = this.promotionForm.secondDiscount.toString()
      if (secondDiscount.indexOf('.') != -1) {
        this.$Message.error('请输入整数且不要有小数点！')
        return
      }
      let validateRes = this.validateForm(form)
      let isValisdateSuccess = validateRes['is_success']
      if (isValisdateSuccess) {
        switch (form) {
          case 'promotionForm':
            this.promotionForm.platformUuid = this.platformUuid
            delete this.promotionForm.id
            if(this.promotionForm.ticketDiscountFloat == ''){
              this.$message.error('请输入折扣')
              return;
            }
            if(this.promotionForm.ticketDiscountFloat > 3 || this.promotionForm.ticketDiscountFloat < -3){
              this.$message.error('只能输入-3~3之间的整数')
              return;
            }
            // 不允许输入小数
            if(this.promotionForm.ticketDiscountFloat.toString().indexOf('.') != -1){
              this.$message.error('请输入整数')
              return;
            }
            setModel
              .savePromotionSet(this.promotionForm)
              .then(response => {
                let res = response.data
                if (res.code == 200) {
                  this.$Message.success('保存成功')
                } else {
                  let message = res.message ? res.message : '系统繁忙请稍后再试！'
                  this.$Message.error(message)
                }
              })
              .catch(error => {
                if (error != 'token invalid') {
                  this.$Message.error('系统繁忙请稍后再试')
                }
              })
            break
          case 'withdrawForm':
            this.withdrawForm.certKeyRsa = this.certKeyRsaList[0] ? this.certKeyRsaList[0]['name'] : ''
            this.withdrawForm.rootCert = this.rootCertList[0] ? this.rootCertList[0]['name'] : ''
            this.withdrawForm.appCert = this.appCertList[0] ? this.appCertList[0]['name'] : ''
            let withdrawFormParam = this.formateInit(this.withdrawForm)
            delete withdrawFormParam.certKeyRsa
            delete withdrawFormParam.rootCert
            delete withdrawFormParam.appCert
            withdrawFormParam.platformUuid = this.platformUuid
            delete withdrawFormParam.id
            if (withdrawFormParam.value) {
              delete withdrawFormParam.value
            }
            // 暂时只传这两个
            // withdrawFormParam = {
            //   withdrawMin:this.withdrawForm.withdrawMin,
            //   withdrawPart:this.withdrawForm.withdrawPart,
            //   platformUuid:this.platformUuid
            // }
            setModel
              .saveWithdrawSet(withdrawFormParam)
              .then(response => {
                let res = response.data
                if (res.code == 200) {
                  this.$Message.success('保存成功')
                } else {
                  let message = res.message ? res.message : '系统繁忙请稍后再试！'
                  this.$Message.error(message)
                }
              })
              .catch(error => {
                if (error != 'token invalid') {
                  this.$Message.error('系统繁忙请稍后再试')
                }
              })
            break
          default:
            // 保存海报
            let posterUrl = []
            for (var i in this.curPosterList) {
              posterUrl.push(this.curPosterList[i].image)
            }
            let param = {
              platformUuid: this.platformUuid,
              posterId: this.userChoosePosterArr.join(','), // 已启用系统海报
              selfPosterId: this.userChooseDefinePosterArr.join(','), // 已启用自定义海报
              posterUrl: posterUrl.join(',') // 已启用海报数组
            }
            setModel
              .setChoosePoster(param)
              .then(response => {
                let res = response.data
                if (res.code == 200) {
                  this.$Message.success('保存成功！')
                } else {
                  let message = res.message ? res.message : '系统异常！请稍后再试'
                  this.$Message.error(message)
                }
              })
              .catch(error => {
                if (error != 'token invalid') {
                  this.$Message.error('系统繁忙请稍后再试')
                }
                console.log(error)
              })
        }
      } else {
        this.$Message.error(validateRes['tip'])
      }
    },
    formateInit(formData) {
      let objCopy = {}
      for (let key in formData) {
        if (formData[key]) {
          objCopy[key] = formData[key]
        }
      }
      return objCopy
    },
    validateForm(form) {
      let res = {}
      switch (form) {
        case 'promotionForm':
          res = this.validatePromotionItem()
          break
        case 'withdrawForm':
          res = this.validatewithdrawItem()
          break
        default:
          res['is_success'] = true
          res['tip'] = '验证成功'
      }
      return res
    },
    validatePromotionItem() {
      let percentOne = this.promotionForm.percentOne
      if (!this.isNumber(percentOne)) {
        return {
          is_success: false,
          tip: '第一级代理分成请填写数字类型！'
        }
      }
      if (parseFloat(percentOne) < 0) {
        return {
          is_success: false,
          tip: '第一级代理分成请填大于等于0的数字'
        }
      }

      let percentTwo = this.promotionForm.percentTwo
      if (!this.isNumber(percentTwo)) {
        return {
          is_success: false,
          tip: '第二级代理分成请填写数字类型！'
        }
      }
      if (parseFloat(percentTwo) < 0) {
        return {
          is_success: false,
          tip: '第二级代理分成请填大于等于0的数字'
        }
      }

      let percentMajor = this.promotionForm.percentMajor
      if (!this.isNumber(percentMajor)) {
        return {
          is_success: false,
          tip: '总监分成分成请填写数字类型！'
        }
      }
      if (parseFloat(percentMajor) < 0) {
        return {
          is_success: false,
          tip: '总监分成请填大于等于0的数字'
        }
      }
      return {
        is_success: true,
        tip: '验证成功'
      }
    },
    validatewithdrawItem() {
      let withdrawMin = this.withdrawForm.withdrawMin
      if (!this.isNumber(withdrawMin)) {
        return {
          is_success: false,
          tip: '最低提现金额填写数字类型！'
        }
      }
      if (parseFloat(withdrawMin) < 0) {
        return {
          is_success: false,
          tip: '最低提现金额请填写大于等于0的数字！'
        }
      }
      this.withdrawForm.withdrawMin = parseFloat(withdrawMin)

      let withdrawPart = this.withdrawForm.withdrawPart
      if (!this.isNumber(withdrawPart)) {
        return {
          is_success: false,
          tip: '提现倍数请填写数字类型！'
        }
      }
      if (parseFloat(withdrawPart) < 0) {
        return {
          is_success: false,
          tip: '提现倍数请填写大于等于0的数字！'
        }
      }
      this.withdrawForm.withdrawPart = parseFloat(withdrawPart)
      if (this.withdrawForm.appid != '') {
        if (!this.withdrawForm.alipayPublicKey) {
          //privateKey和alipayPublicKey
          return {
            is_success: false,
            tip: '请填写支付宝公钥！'
          }
        }

        if (!this.withdrawForm.privateKey) {
          //privateKey和alipayPublicKey
          return {
            is_success: false,
            tip: '请填写应用私钥！'
          }
        }
      }
      return {
        is_success: true,
        tip: '验证成功'
      }
    },
    getPromotionSet: function () {
      let param = {}
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (!condition) {
        param.platformUuid = this.platformUuid
      }
      let that = this
      setModel
        .getPromotionSet(param)
        .then(response => {
          let res = response.data
          if (res.code == 200) {
            //选中的推广方式
            that.methodGroup = []
            if (res.data && res) {
              let condition = res.data ? JSON.stringify(res.data) == '{}' : true
              if (!condition) {
                that.promotionForm = res.data
              }

              let ticketArr = []
              if (this.promotionForm.openCompete) {
                ticketArr.push(0)
              }
              if (this.promotionForm.openDirect) {
                ticketArr.push(1)
              }
              if (this.promotionForm.openSoon) {
                ticketArr.push(2)
              }
              if (this.promotionForm.openMayiSwitch) {
                ticketArr.push(3)
              }

              let ticketType = ticketArr.join(',')
              this.promotionForm.ticketType = ticketType
              let platformUuid = that.platformUuid == 0 ? '' : that.platformUuid
              if (ticketType == '' && platformUuid == '') {
                ticketType = '0,1'
              }
              that.selectIndexStr = ticketType
              let tempMethodGrop = ticketType.split(',')
              if (tempMethodGrop.length > 0) {
                let i
                for (i = 0; i < tempMethodGrop.length; i++) {
                  let tempIndex = tempMethodGrop[i]
                  let tempLabel = that.allMethodGrop[tempIndex] ? that.allMethodGrop[tempIndex] : ''
                  if (tempLabel) {
                    that.methodGroup.push(tempLabel)
                  }
                }
              }
            }
          } else {
            let message = res.message ? res.message : '系统繁忙请稍后再试！'
            that.$Message.error(message)
          }
        })
        .catch(error => {
          console.log(error)
          if (error != 'token invalid') {
            that.$Message.error('系统繁忙请稍后再试')
          }
        })
    },
    getWithdrawSet: function () {
      let param = {}
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (!condition) {
        param.platformUuid = this.platformUuid
      }

      let that = this
      setModel
        .getWithdrawSet(param)
        .then(response => {
          let res = response.data
          if (res.code == 200) {
            if (res.data) {
              let conditionObj = res.data instanceof Object
              let emptyObj = false
              let emptyArr = false
              let conditionArr = res.data instanceof Array
              if (conditionObj) {
                let dataInfo = res.data
                let arr = Object.keys(dataInfo)
                if (arr.length == 0) {
                  emptyObj = true
                }
              }
              if (conditionArr) {
                if (res.data.length == 0) {
                  emptyArr = true
                }
              }
              if (!emptyObj && !emptyArr) {
                that.withdrawForm = res.data
              }

              that.percent = res.data.value
              if (res.data.rootCert) {
                that.rootCert = res.data.rootCert
              }
              if (res.data.certKeyRsa) {
                that.certKeyRsa = res.data.certKeyRsa
              }
              if (res.data.appCert) {
                that.appCert = res.data.appCert
              }
              this.startTime = res.data.startHour
              this.endTime = res.data.endHour
              this.openRadio = res.data.isSwitch
              console.log('this.openRadio', this.openRadio)
            }
          } else {
            let message = res.message ? res.message : '系统繁忙请稍后再试！'
            that.$Message.error(message)
          }
        })
        .catch(error => {
          if (error != 'token invalid') {
            that.$Message.error('系统繁忙请稍后再试')
          }
        })
    },
    getService: function () {
      getServerConfig()
        .then(response => {
          this.loading = false
          this.wechat_code = response.data.wechat_code
          this.$refs.Service.init(true, this.wechat_code)
        })
        .catch(error => {
          this.loading = false
          console.log(error)
          this.$Message.error('加载客服信息失败,请稍后再试!')
        })
    },
    isChecked: function (id) {
      let tempIndex = -1
      let i
      for (i = 0; i < this.userChoosePosterArr.length; i++) {
        if (this.userChoosePosterArr[i] == id) {
          tempIndex = i
          break
        }
      }
      return tempIndex >= 0
    },
    isCheckedDefine: function (id) {
      let tempIndex = -1
      let i
      for (i = 0; i < this.userChooseDefinePosterArr.length; i++) {
        if (this.userChooseDefinePosterArr[i] == id) {
          tempIndex = i
          break
        }
      }
      return tempIndex >= 0
    },
    setPrivateKey: function () {
      this.$refs.PrivateKey.init(true, this.withdrawForm)
    },
    setPublicKey: function () {
      this.$refs.PublicKey.init(true, this.withdrawForm)
    },
    choosePoster: function (item) {
      let i
      let tempIndex = -1
      for (i = 0; i < this.userChoosePosterArr.length; i++) {
        if (this.userChoosePosterArr[i] == item.id) {
          tempIndex = i
          break
        }
      }
      if (tempIndex === -1) {
        this.userChoosePosterArr.push(item.id)
        item.type = 0
        this.curPosterList.push(item)
      } else {
        this.userChoosePosterArr.splice(tempIndex, 1)
        this.delUserCurPoster(item.id, 0, null)
      }
    },
    isNumber(num) {
      if (parseFloat(num).toString() == 'NaN') {
        return false
      } else {
        return true
      }
    },
    ajaxUploadCA(params) {
      // type 取值 rsa-支付宝公钥  root -支付宝ca app-应用公钥
      let that = this
      const formData = new window.FormData()
      formData.append('file', params.file)
      formData.append('type', 'root')
      formData.append('platformUuid', that.platformUuid)
      setModel
        .uoloadFile(formData)
        .then(response => {
          let res = response.data
          let message = res.message ? res.message : '系统异常，请稍后再试'
          if (res.success) {
            if (res.saveName) {
              that.alipayCAPath = res.saveName
            } else {
              that.$Message.error('上传失败！')
            }
          } else {
            that.$Message.error(message)
          }
        })
        .catch(error => {
          if (error != 'token invalid') {
            that.$Message.error('系统异常！请稍后再试！')
          }
        })
    },
    ajaxUploadAlipayPublic(params) {
      // type 取值 rsa-支付宝公钥  root -支付宝ca app-应用公钥
      let that = this
      const formData = new window.FormData()
      formData.append('file', params.file)
      formData.append('type', 'rsa')
      formData.append('platformUuid', that.platformUuid)
      setModel
        .uoloadFile(formData)
        .then(response => {
          let res = response.data
          let message = res.message ? res.message : '系统异常，请稍后再试'
          if (res.success) {
            if (res.saveName) {
              that.alipayPublicKeyPath = res.saveName
            } else {
              that.$Message.error('上传失败！')
            }
          } else {
            that.$Message.error(message)
          }
        })
        .catch(error => {
          if (error != 'token invalid') {
            that.$Message.error('系统异常！请稍后再试！')
          }
        })
    },
    ajaxBeforeUpload() {
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (condition) {
        this.$Message.info('请先授权公众号再上传文件')
        return false
      }
    },
    ajaxBeforeUploadPublic() {
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (condition) {
        this.$Message.info('请先授权公众号再上传文件')
        return false
      }
      if (this.rootCertList.length > 0) {
        this.$Message.info('最多只能上传一个文件，请移除文件列表里的文件')
        return false
      }
    },
    ajaxUploadApp(params) {
      // type 取值 rsa-支付宝公钥  root -支付宝ca app-应用公钥
      console.log(params)
      let that = this
      const formData = new window.FormData()
      formData.append('file', params.file)
      formData.append('type', 'app')
      formData.append('platformUuid', that.platformUuid)
      console.log(formData)
      setModel
        .uoloadFile(formData)
        .then(response => {
          let res = response.data
          let message = res.message ? res.message : '系统异常，请稍后再试'
          if (res.success) {
            if (res.filePath) {
              that.applicationRootPath = res.filePath
            } else {
              that.$Message.error('上传失败！')
            }
          } else {
            that.$Message.error(message)
          }
        })
        .catch(error => {
          if (error != 'token invalid') {
            this.$Message.error('系统异常！请稍后再试！')
          }
        })
    },
    //上传自定义海报
    ajaxUpLoadPoster(params) {
      let that = this
      const formData = new window.FormData()
      formData.append('file', params.file)
      formData.append('platformUuid', that.platformUuid)
      setModel
        .uoloadDefinePoster(formData)
        .then(response => {
          let res = response.data
          let message = res.message ? res.message : '系统异常，请稍后再试'
          if (res.success) {
            if (res.data.id && res.data.url) {
              that.definePosterList.push({id: res.data.id, image: res.data.url})
            } else {
              that.$Message.error('上传失败！')
            }
          } else {
            that.$Message.error(message)
          }
        })
        .catch(error => {
          if (error != 'token invalid') {
            this.$Message.error('系统异常！请稍后再试！')
          }
        })
    },
    //删除自定义海报
    delDefinePoster(id) {
      var that = this
      this.$confirm('确定删除该海报？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let param = {
            platformUuid: this.platformUuid,
            selfPosterId: id
          }
          setModel
            .delDefinePoster(param)
            .then(response => {
              let res = response.data
              let message = res.message ? res.message : '系统异常，请稍后再试'
              if (res.success) {
                let i
                let tempIndex = -1
                for (i = 0; i < that.userChooseDefinePosterArr.length; i++) {
                  if (that.userChooseDefinePosterArr[i] == id) {
                    tempIndex = i
                    break
                  }
                }
                if (tempIndex > -1) {
                  that.userChooseDefinePosterArr.splice(tempIndex, 1)
                  that.delUserCurPoster(id, 1, null)
                }
                that.delUserDefinePoster(id)
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              } else {
                that.$Message.error(message)
              }
            })
            .catch(error => {
              if (error != 'token invalid') {
                this.$Message.error('系统异常！请稍后再试！')
              }
            })
        })
        .catch(() => {
        })
    },
    //启用或禁用自定义海报
    chooseDefinePoster(item) {
      let i
      let tempIndex = -1
      for (i = 0; i < this.userChooseDefinePosterArr.length; i++) {
        if (this.userChooseDefinePosterArr[i] == item.id) {
          tempIndex = i
          break
        }
      }
      if (tempIndex === -1) {
        this.userChooseDefinePosterArr.push(item.id)
        item.type = 1
        this.curPosterList.push(item)
      } else {
        this.userChooseDefinePosterArr.splice(tempIndex, 1)
        this.delUserCurPoster(item.id, 1, null)
      }
    },
    //删除已启用海报
    delCurPoster(item) {
      console.log("debug:________________delCurPoster______________");
      if (item.type == 0) {
        // let i
        // let tempIndex = -1
        // for (i = 0; i < this.userChoosePosterArr.length; i++) {
        //   if (this.userChoosePosterArr[i] == item.id) {
        //     tempIndex = i
        //     break
        //   }
        // }
        // if (tempIndex > -1) {
        //   this.userChoosePosterArr.splice(tempIndex, 1)
        //   this.delUserCurPoster(item.id, item.type, null)
        // }
        this.delUserCurPoster(item.id, item.type, null)
      } else if (item.type == 1) {
        let ii
        let tempIndex = -1
        for (ii = 0; ii < this.userChooseDefinePosterArr.length; ii++) {
          if (this.userChooseDefinePosterArr[ii] == item.id) {
            tempIndex = ii
            break
          }
        }
        if (tempIndex > -1) {
          this.userChooseDefinePosterArr.splice(tempIndex, 1)
          this.delUserCurPoster(item.id, item.type, null)
        }
      }
    },
    // 升序
    sortCurPoster(item) {
      let i
      let tempIndex = -1
      for (i = 0; i < this.curPosterList.length; i++) {
        if (this.curPosterList[i].type == item.type && this.curPosterList[i].id == item.id) {
          tempIndex = i
          break
        }
      }
      if (tempIndex > 0) {
        let tempPosterItem = this.curPosterList[tempIndex - 1]
        this.curPosterList.splice(tempIndex - 1, 1, item)
        this.curPosterList.splice(tempIndex, 1, tempPosterItem)
      }
    },
    // 删除已启用海报（公共方法）
    delUserCurPoster(id, type, item) {
      let i
      for (i = 0; i < this.curPosterList.length; i++) {
        if (this.curPosterList[i].type == type && this.curPosterList[i].id == id) {
          if (item != null) {
            this.curPosterList.splice(i, 1, item)
          } else {
            this.curPosterList.splice(i, 1)
          }
          break
        }
      }
    },
    // 删除自定义海报
    delUserDefinePoster(id) {
      let i
      for (i = 0; i < this.definePosterList.length; i++) {
        if (this.definePosterList[i].id == id) {
          this.definePosterList.splice(i, 1)
          break
        }
      }
    },
    //获取开始时间
    getStartTime(e) {
      this.startTime = e
    },
    //获取结束时间
    getEndTime(e) {
      this.endTime = e
    },
    //开启or关闭
    getRadio(index) {
      this.openRadio = index
    },
    // 提交
    saveButton() {
      if (this.startTime == '') {
        this.$message.error('请输入开始时间')
        return
      }
      if (this.endTime == '') {
        this.$message.error('请输入结束时间')
        return
      }
      let params = {
        platformUuid: this.platformUuid,
        isSwitch: this.openRadio,
        startHour: this.startTime,
        endHour: this.endTime
      }
      setModel.saveSwitch(params).then(res => {
        console.log(res)
        if (res.data.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  //min-width: 770px;
  font-size: 12px;

  .tilte-text {
    font-size: 18px;
    color: #222222;
    text-align: left;
    font-family: Alibaba-PuHuiTi-M;
  }

  .select-wrap {
    padding-top: 20px;

    .select-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 34px 20px 34px 40px;
      border-radius: 4px;
      background: #fafafa;
      border: 1px solid #fafafa;
    }

    .select-box.active {
      background: #fffbf7;
      border: 1px solid #ff8622;
    }

    .select-div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .method-img {
        width: 60px;
        margin-right: 10px;
      }

      .method {
        font-family: Alibaba-PuHuiTi-R;
        font-size: 18px;
        color: #666666;
      }
    }

    .select-img {
      width: 40px;
    }

    .save-div {
      margin-top: 60px;
      text-align: center;

      .save-btn {
        background: #ff8622;
        border-radius: 2px;
        font-family: Alibaba-PuHuiTi-R;
        font-size: 13px;
        color: #ffffff;
        padding: 8px 40px;
        cursor: pointer;
      }
    }
  }

  .setting-wrap {
    .tab-box {
      padding-top: 27px;
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #eeeeee;

      .tab-div {
        padding: 0 20px;
        font-size: 16px;
        color: #999999;
        line-height: 28px;
        cursor: pointer;
      }

      .tab-div.active {
        color: #ff8622;
      }

      .tab-div .line {
        background: #ff8622;
        height: 2px;
      }
    }

    .form-wrapper {
      margin-top: 30px;

      .form-group {
        display: flex;

        .input-wrap {
          max-width: 134px;
          min-width: 134px;
          margin-right: 4px;
          color: #222222;
        }
      }

      .confirm-btn {
        background: #ff8622;
        border-radius: 2px;
        font-size: 13px;
        color: #ffffff;
        cursor: pointer;
        padding: 8px 25px;
      }

      .add-poster {
        margin: 15px 20px;

        .upload-demo {
          display: flex;

          .el-upload__tip {
            margin-left: 15px;
          }
        }
      }

      .poster-wrap {
        margin-top: 20px;
        border: 1px solid #eeeeee;
        border-radius: 4px;
        color: #222222;
        overflow: auto;
        zoom: 1;

        .poster-wrap-item {
          .tilte-text {
            margin: 15px 20px 0;
          }

          .poster-item {
            overflow: hidden;

            .flex-space-between {
              width: 80%;
              margin: 10px auto;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .del-btn,
              .sort-btn {
                cursor: pointer;
              }

              .radio-div {
                margin: 0;
              }
            }
          }
        }

        .poster-box {
          float: left;
          width: 140px;
          padding: 0px 10px 20px 10px;

          .poster-div {
            img {
              width: 120px;
              height: 213px;
            }
          }

          .radio-div {
            text-align: center;
            margin-top: 10px;

            img {
              width: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}

>>> .ivu-form-item-label {
  font-size: 14px;
  color: #666666;
}

>>> .ivu-form-item-label {
  line-height: 16px;
}

>>> .ivu-form .ivu-form-item-label {
  color: #666666;
}

>>> .ivu-input:focus {
  border: 1px solid #ff8622 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 150, 43, 0.6) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 150, 43, 0.6) !important;
  outline: none;
}

>>> .ivu-input:hover {
  border-color: #ff8622;
}

>>> .ivu-radio-checked .ivu-radio-inner {
  border-color: #ff8622;
}

>>> .ivu-radio-checked .ivu-radio-inner:after {
  background-color: #ff8622;
}

>>> .ivu-radio-checked:hover .ivu-radio-inner {
  border-color: #ff8622;
}

>>> .ivu-radio-focus {
  z-index: 1;
  -webkit-box-shadow: none;
  box-shadow: none;
}

>>> .ivu-input {
  border-radius: 2px;
  border: 1px solid #eeeeee;
}

>>> textarea {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  outline: none;
  width: 280px;
  padding: 0px 6px;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c1c1c1;
}

input::-webkit-input-placeholder,
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c1c1c1;
}

input::-webkit-input-placeholder,
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c1c1c1;
}

input::-webkit-input-placeholder,
textarea::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #c1c1c1;
}

/*提现设置*/
.main {
  margin-top: 40px;
}

.main-flex {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.main-title {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-family: Alibaba-PuHuiTi-M;
}

.flex-text {
  width: 130px;
  font-size: 16px;
}

.flex-radio {
  margin-left: 80px;
}

.flex-input {
  margin-left: 80px;
}

.main-button {
  margin-top: 60px;
  text-align: center;
}

.button-save {
  background: #ff8622;
  border-radius: 2px;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #ffffff;
  padding: 8px 40px;
  cursor: pointer;
}

.flex {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.form-title {
  font-size: 16px;
  color: #222222;
  text-align: left;
  font-family: Alibaba-PuHuiTi-M;
  font-weight: 500;
  border-left: 2px solid #ff8622;
  padding-left: 10px;
  margin-bottom: 20px;
  line-height: 15px;
}

.form-div {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
}
.form-div{
  font-size: 14px;
}
.form-div-hint{
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 17px;
  margin-left: 10px;
  width: 60%;
}
.bottom{
  background: #FAFAFA;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 20px;
}
.bottom-title{
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 17px;
  display: flex;
  align-items: center;
}
.bottom-title img{
  width: 20px;
  height: 20px;
}
.bottom-text{
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 17px;
  margin-left: 20px;
}
.form-div-text{
  width: 100px;
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none!important;
}
/deep/ input[type="number"]{
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/set/Index.vue